//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { Opaque } from '@utils/opaque';

type FileId = Opaque<string, 'FileId'>;

function FileIdFactory(fileId: string) {
  return fileId as FileId;
}

const FileId = FileIdFactory;

export default FileId;
